import { useState } from 'react';
import * as d3 from 'd3';

import useFetch from './useFetch';

function useMap() {
  const {
    res: [geojson, cpw],
    fetching,
  } = useFetch(
    ['/wp-content/ippd-content/plasticstory/data/regulation.geo.json', '/wp-content/ippd-content/plasticstory/data/cpw.csv'],
    [
      JSON.parse,
      (txt) =>
        d3.csvParse(txt, (txt) => {
          txt.year = d3.timeParse('%Y')(txt.year);
          txt.cpw = +txt.cpw;
          return txt;
        }),
    ]
  );

  const [step, setStep] = useState(null);

  const [year, setYear] = useState(null);

  return { fetching, geojson, cpw, step, setStep, year, setYear };
}

export default useMap;
